// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3EDms","signatureButtonsRight":"ModalSign_signatureButtonsRight__2Dg7j"};